import React from 'react';

export const NotFound = () => {
  return (
      <div className="not-found">
          <h2>User not found</h2>
      </div>
  );
};
